import CardChartDropDown from '@/components/common/CardChartDropDown';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import Flex from '@/components/common/Flex';
import MainBarChart from '@/app/common/components/charts/BarChart';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { useRef } from 'react';
import { Card } from 'react-bootstrap';
import _ from 'lodash';
import timeStampToDate from '@/helpers/timeStampToDate';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '@/Main';
import { showDrawer } from '@/app/common/reducers/drawer';


const ProgressDeclineOfKeywordsChart = ({ data }) => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  const cardRef = useRef(null);
  const chartRef = useRef(null);
  const {
    config: { isRTL }
  } = useAppContext();
  const dispatch = useDispatch();

  const series = [
    {
      name: 'رشد کلمات',
      data: data?.map(item => item.num_of_interrupted),
      itemStyle: {
        color: getColor('success'),
        borderRadius: [3, 3, 0, 0]
      }
    },
    {
      name: 'افت کلمات',
      data: data?.map(item => -item.num_of_dropped),
      itemStyle: {
        color: getColor('danger'),
        borderRadius: [0, 0, 3, 3]
      }
    }
  ];

  return (
    <Card ref={cardRef} className="h-100">
      <FalconCardHeader
        title={
          <div>
            رشد / افت کلمات
            <FontAwesomeIcon
              icon={['far', 'question-circle']}
              transform="shrink-1"
              style={{
                transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)',
                pointerEvents: 'all'
              }}
              className={`ms-1 text-400 cursor-pointer check-list-item`}
              id="weeklySalesTooltip"
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();

                dispatch(
                  showDrawer({
                    key: 'help',
                    payload: {
                      title: ' رشد / افت کلمات',
                      tooltip: '',
                      manualData: (
                        <div>
                          <h5 className="mb-3">درباره این موضوع</h5>
                          <p className="lh-lg">
                            این بخش زمانی نمایش داده میشه که حداقل ۲ بار کلمات
                            کلیدی رو به‌روزرسانی کرده باشی. سه عدد کلی در این
                            بخش هست، عدد سبز که نشون دهنده اینکه چه تعداد کلمه
                            کلیدی در اخرین به‌روزرسانی که صورت گرفته رشد در رتبه
                            گوگل داشتن، مثلا قبلا یک کلمه کلیدی رتبه ۱۰ در گوگل
                            داشته و الان رتبه ۵ داره و یا در یک کلمه کلیدی شما
                            بدون رتبه بودید و الان یک رتبه‌ای مثل رتبه ۸۰ در
                            گوگل دارید (به کلماتی که بدون رتبه هستن و بعدش رتبه
                            دار میشن اصولا میگیم ورود داشتن). همه این نمونه‌ها
                            رشد حساب میشن و تعداد این کلماتی که رشد کردن رو جمع
                            میکنیم و به شما در قالب یک عدد سبز نشون میدیم. عدد
                            قرمز هم برعکس توضیحات بالا هست و نشان دهنده تعداد
                            کلمات کلیدی هست که طبق آخرین به‌روزرسانی افت رتبه در
                            گوگل داشتن. عدد مشکی خاکستری نشان دهنده تعداد کلمات
                            کلیدی هست که طبق آخرین به‌روزرسانی هیچ تغییری در
                            رتبه نداشتن و در نتایج گوگل جابه‌جا نشدن. مثلا اگر
                            یک کلمه قبلا رتبه ۳ بوده الانم رتبه ۳ هست و یا اگر
                            کلمه‌ای قبلا بدون رتبه بوده، الانم بدون رتبه هست.
                          </p>
                          <h5 className="mb-3">چطور استفاده کنیم؟</h5>
                          <p className="lh-lg">
                            این نمودار خیلی واضح و روشن داره به ما میگه چقدر رشد
                            یا افت داشتیم،طبیعتا وقتی عدد قرمز خیلی بیشتر از عدد
                            سبز میشه باید حتما یک بررسی دقیق و جزئی به سئو و
                            کلمات کلیدی داشته باشید و علت افت رو متوجه بشید. ولی
                            دو نکته مهم رو فراموش نکنید: نکته اول: ممکنه عدد افت
                            رتبه شما مثلا ۱۵ باشه و عدد رشد شما مثلا ۵ باشه، در
                            این صورت ممکنه فکر کنید سایت شما خیلی افت بدی داشته
                            ولی ممکنه اینطوری هم نباشه، چرا؟ چون ممکنه اون عدد
                            ۱۵ داره کلماتی رو نشون میده که افت بسیار کمی داشتن و
                            اون عدد ۵ که عدد رشد هست داره کلماتی رو نشون میده که
                            رشد خیلی خوبی داشتن، به عبارت دیگه شما در یک کلمه
                            قبلا رتبه ۱۵ بودی و الان رتبه ۱۴ شدی، درسته که این
                            یک افت هست ولی افت زیاد و قابل متوجه نیست، پس بهتره
                            در ستون کلمات به عدد تغییرات رتبه توجه کنی. نکته
                            دوم: ممکنه افت‌ها یا رشد‌های شما بیشتر در رتبه‌های
                            ۵۱ الی ۱۰۰ گوگل هست تا در ۱ الی ۵۰ گوگل. باید توجه
                            داشته باشی که در رتبه‌های ۵۱ الی ۱۰۰ نوسان رتبه
                            بسیار زیاد هست ولی پایدار نیست درحالی که در ۱ الی ۵۰
                            این نوسان‌ها کمتره و پایدارتر هست. به عبارت دیگه،
                            وقتی شما در یک کلمه رتبه ۸۰ داشتی و الان رتبه ۱۰۰
                            داری، نباید خیلی نگران این افت باشی و بهتر هست بگیم
                            این یک افت خیلی واقعی نیست، ولی اگر رتبه ۷ بودی و
                            الان رتبه ۱۱ شدی، بهتره یک بررسی دقیق داشته باشی.
                            همین موضوع برای رشدها هم صدق می‌کنه. اگر خواستید
                            خیلی جامع و کامل و به صورت ویدیویی این بخش یاد
                            بگیرید، وارد این{' '}
                            <a
                              href="https://help.mizfa.tools/professional-analysis-mizfa-tools/"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              این صفحه
                            </a>{' '}
                            شید و ویدیو ۱ قسمت ۱ نگاه کنید.
                          </p>
                        </div>
                      )
                    }
                  })
                );
              }}
            />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-3"
      >
        <MainBarChart
          chartRef={chartRef}
          height={'10rem'}
          categories={data?.map(item => item.update_date)}
          series={series}
          min={_.min([
            data?.map(item => -item.num_of_dropped),
            data?.map(item => item.num_of_interrupted)
          ])}
          tooltipFunc={params => {
            let tooltipItem = ``;
            params.forEach(el => {
              tooltipItem =
                tooltipItem +
                `
        <div class="text-700 d-flex flex-row align-items-center justify-content-between w-100 gap-1">
          <span class="text-800 d-flex flex-row-reverse align-items-center gap-1">${el.seriesName}${el.marker}</span>
          <span class="d-flex align-items-center gap-1">
                <span class="fw-bold text-1000">${Math.abs(el?.value * -1)
                  ?.toString()
                  ?.toPersianDigit()}</span>
          </span>
        </div>`;
            });
            return `
              <div style="width:${isMdUp && '200px'};" class="d-flex flex-column align-items-end">
                    <p class='mb-2 text-1000 fw-bold w-100'>
                      ${timeStampToDate(Number(params[0].axisValue))
                        .slice(8)
                        .toPersianDigit()}
                    </p>
                    
                    ${tooltipItem}
              </div>`;
          }}
        />
      </Card.Body>
    </Card>
  );
};

export default ProgressDeclineOfKeywordsChart;
